import { isCurewiki, isPEC } from './domain.constant';
import {
  COLOR_BASE_200,
  COLOR_BASE_300,
  COLOR_BASE_900,
  COLOR_ERROR,
  COLOR_PRIMARY_100,
  curewikiAntdTheme,
  FONT_FAMILY_INTER,
  FONT_FAMILY_WORK_SANS,
} from './style.constant';

export const getConfigTheme = (bgColor: string) => ({
  token: {
    ...(isCurewiki ? curewikiAntdTheme : { colorPrimary: bgColor }),
    fontFamily: isPEC ? FONT_FAMILY_WORK_SANS : FONT_FAMILY_INTER,
    colorError: COLOR_ERROR,
  },
  components: {
    Tooltip: { borderRadius: 4, colorBgSpotlight: COLOR_BASE_900, fontSize: 12 },
    Table: {
      colorFillAlter: COLOR_BASE_200,
      colorBorderSecondary: COLOR_BASE_200,
      borderRadiusSM: 12,
      borderRadius: 12,
      borderRadiusLG: 12,
      rowSelectedBg: COLOR_PRIMARY_100,
      rowSelectedHoverBg: COLOR_BASE_300,
    },
    Pagination: {
      fontWeightStrong: 500,
      borderRadius: 100,
    },
    Input: {
      borderRadiusSM: 100,
      borderRadius: 100,
      borderRadiusLG: 100,
    },
    Select: {
      borderRadiusSM: 12,
      borderRadius: 100,
      borderRadiusLG: 12,
      colorTextPlaceholder: COLOR_BASE_900,
    },
    DatePicker: { borderRadiusSM: 12, borderRadius: 100, borderRadiusLG: 12 },
  },
});
